import * as classNames from 'classnames';
import { IconButton, IIconButtonProps } from 'components/action';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./SectionHeadline.css');

// Props
interface ISectionHeadlineProps {
    title?: string;
    details?: string;
    button?: IIconButtonProps;
    placeChildrenInTheMiddle?: boolean;
    className?: string;
    classNameForHeadline?: string;
}

// Component
@observer
export class SectionHeadline extends React.Component<
    ISectionHeadlineProps,
    {}
> {
    static get defaultProps(): ISectionHeadlineProps {
        return {
            title: null,
            details: null,
            button: null,
            placeChildrenInTheMiddle: false,
            className: null,
            classNameForHeadline: null,
        };
    }

    public render() {
        const {
            title,
            details,
            button,
            placeChildrenInTheMiddle,
            className,
            classNameForHeadline,
        } = this.props;

        // Render
        return (
            <div className={classNames(s.container, className)}>
                <h2 className={classNames(s.headline, classNameForHeadline)}>
                    {title && <span>{title}</span>}
                    {details && <em>{details}</em>}
                </h2>

                {placeChildrenInTheMiddle && this.props.children && (
                    <div className={s.middle}>{this.props.children}</div>
                )}

                <div className={s.right}>
                    {placeChildrenInTheMiddle === false && this.props.children}

                    {button && (
                        <IconButton
                            className={s.iconButton}
                            onClick={this.handleButtonClick}
                            label={
                                typeof button.label !== 'undefined' &&
                                button.label
                                    ? button.label
                                    : undefined
                            }
                            labelClassName={
                                typeof button.labelClassName !== 'undefined' &&
                                button.labelClassName
                                    ? button.labelClassName
                                    : undefined
                            }
                            iconClassName={
                                typeof button.iconClassName !== 'undefined' &&
                                button.iconClassName
                                    ? button.iconClassName
                                    : undefined
                            }
                            showLabel={
                                typeof button.showLabel !== 'undefined' &&
                                button.showLabel !== null
                                    ? button.showLabel
                                    : undefined
                            }
                            icon={
                                typeof button.icon !== 'undefined' &&
                                button.icon
                                    ? button.icon
                                    : undefined
                            }
                        />
                    )}
                </div>
            </div>
        );
    }

    // Handle button click
    private handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (
            typeof this.props.button !== 'undefined' &&
            this.props.button.onClick
        ) {
            this.props.button.onClick(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/content/SectionHeadline.tsx